/**
 * Created by Jerker Nord on 2018-08-17.
 */
import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {ResourcesGroupName} from "@nolimitcity/slot-game/bin/core/resource/ResourcesGroupName";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {WinRatioType} from "@nolimitcity/slot-game/bin/core/winpresentation/WinRatio";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {Linear, Power2, TimelineLite, TweenLite} from "gsap";
import {BasicBitmapCountUp} from "../../display/BasicBitmapCountUp";
import {IceIceYetiGameAssets} from "../../IceIceYetiGameAssets";
import {IceIceYetiGameConfig} from "../../IceIceYetiGameConfig";
import {IceIceYetiSoundConfig} from "../../IceIceYetiSoundConfig";
import {OpenSans} from "@nolimitcity/slot-launcher/bin/loader/font/OpenSans";
import {FontWeight} from "@nolimitcity/slot-launcher/bin/loader/font/FontStatics";
import {Translation} from "@nolimitcity/slot-game/bin/core/translation/Translation";

export class IceIceYetiWinCountUpView extends BaseView {

    private static WAYS_TEXT_POSITION: PIXI.Point = new PIXI.Point(10, 50);
    private static WAYS_TEXT_STYLE: PIXI.TextStyle = new PIXI.TextStyle(
        {
            dropShadow: true,
            dropShadowAngle: 1.4,
            dropShadowBlur: 3,
            dropShadowDistance: 6,
            fill: [
                "#fdf451",
                "#f4b940"
            ],
            fontFamily: OpenSans.FAMILY,
            fontSize: 56,
            fontWeight: FontWeight.BOLD,
            stroke: "#ffed7a",
            strokeThickness: 1
        }
    );

    private _layer:ScalableLayer;
    private _countText:BasicBitmapCountUp;
    private _scaleContainer:PIXI.Container;
    private _hasStopped:boolean;
    private _smallWinAnimation:TimelineSprite;
    private _mediumWinAnimation:TimelineSprite;
    private _largeWinAnimation:TimelineSprite;
    private _winAnimation:TimelineSprite;
    private _winCountupSoundRunning:boolean = false;
    private _winAnimationPlayed:boolean = false;
    private _waysText: PIXI.Text;
    private _displayIndividualWinsInGame:boolean;

    constructor(resourcesGroup:ResourcesGroupName) {
        super(resourcesGroup);
        this._layer = StageManager.getLayer(IceIceYetiGameConfig.instance.LAYERS.WIN_PRESENTATIONS.name);
        this._layer.addChild(this);
    }

    protected initAnimations() : void {
        this._scaleContainer = new PIXI.Container();
        this._scaleContainer.position.set(640, 320);
        this._scaleContainer.alpha = 0;
        this._countText = new BasicBitmapCountUp(IceIceYetiGameConfig.TEXT_STYLES.WIN_COUNTUP_NUMBERS_TEXT_STYLE);

        this._smallWinAnimation = new TimelineSprite((GameResources.getTextures(IceIceYetiGameAssets.SMALL_WIN)));
        this._smallWinAnimation.blendMode = PIXI.BLEND_MODES.ADD;
        this._smallWinAnimation.anchor.set(0.5, 0.6);
        this._smallWinAnimation.scale.set(2, 2);
        this._smallWinAnimation.alpha = 0;
        this._scaleContainer.addChild(this._smallWinAnimation);

        this._mediumWinAnimation = new TimelineSprite((GameResources.getTextures(IceIceYetiGameAssets.MEDIUM_WIN)));
        this._mediumWinAnimation.blendMode = PIXI.BLEND_MODES.ADD;
        this._mediumWinAnimation.anchor.set(0.5, 0.6);
        this._mediumWinAnimation.scale.set(2, 2);
        this._mediumWinAnimation.alpha = 0;
        this._scaleContainer.addChild(this._mediumWinAnimation);

        this._largeWinAnimation = new TimelineSprite((GameResources.getTextures(IceIceYetiGameAssets.LARGE_WIN)));
        this._largeWinAnimation.blendMode = PIXI.BLEND_MODES.ADD;
        this._largeWinAnimation.anchor.set(0.5, 0.6);
        this._largeWinAnimation.scale.set(2, 2);
        this._largeWinAnimation.alpha = 0;
        this._scaleContainer.addChild(this._largeWinAnimation);

        this._waysText = new PIXI.Text("", IceIceYetiWinCountUpView.WAYS_TEXT_STYLE);
        this._waysText.anchor.set(0.5, 0.5);
        this._waysText.position = IceIceYetiWinCountUpView.WAYS_TEXT_POSITION;
        this._waysText.visible = false;
        this._scaleContainer.addChild(this._waysText);
        this._scaleContainer.addChild(this._countText);
        this.addChild(this._scaleContainer);
    }

    public getWinDisplay(totalWinWays:number, from:number, to:number, duration:number, winType:WinRatioType, continueCounting:boolean = false, belowStake:boolean = false):TimelineLite {
        this._hasStopped = false;
        this._displayIndividualWinsInGame = SlotGame.api.gameClientConfiguration.displayIndividualWinsInGame;
        if (this._displayIndividualWinsInGame == true){
            const waysText: string = (totalWinWays == 1 ? "Way Won" : "Ways Won");
            this._waysText.text = totalWinWays + " " + Translation.translate(waysText);
        }
        this._waysText.visible = this._displayIndividualWinsInGame;
        const count:TimelineLite = new TimelineLite();

        if (!belowStake) {
            count.add(() => SlotGame.sound.playEffect(this.getWinTypeSound(winType)));
        }else {
            this._winAnimationPlayed = true;
        }

        if(!continueCounting) {
            count.add(() => this._scaleContainer.scale.set(0));
            count.add(() => this._scaleContainer.alpha = 0);
        }
        if(winType == WinRatioType.TINY) {
            from = to;
            duration = 0;
        }

        if (!belowStake){
            count.add(() => this.playCountUpSound(duration));
        }

        count.add([
            new TweenLite(this._scaleContainer.scale, 0.3, {
                x : this.getWinTypeScale(winType),
                y : this.getWinTypeScale(winType),
                ease : Power2.easeOut
            }),
            new TweenLite(this._scaleContainer, 0.2, {alpha : 1, ease : Linear.easeOut}),
            this._countText.getCountAnimation(from, to, duration),
        ]);
        count.add(this.getWinAnimationTL(winType));

        if (belowStake){
            count.add(new TweenLite(this, 1.5, {})); //Just some padding to not remove the number to quickly on below stake.
        }

        return count;
    }

    private getWinAnimationTL(winType:WinRatioType):TimelineLite {
        let winAnimationTL:TimelineLite = new TimelineLite();
        if(this._winAnimationPlayed == false) {
            winAnimationTL.add([
                () => this._winAnimationPlayed = true,
                () => this._winAnimation = this.getWinAnimation(winType),
                () => this._winAnimation.alpha = 1,
                () => this._winAnimation.getAnimation()
            ]);
        }
        return winAnimationTL;
    }

    private playCountUpSound(duration:number):void {
        if(duration > 0.1) {
            SlotGame.sound.playEffect(IceIceYetiSoundConfig.instance.COUNTUP, -1);
            this._winCountupSoundRunning = true;
        } else {
            SlotGame.sound.playEffect(IceIceYetiSoundConfig.instance.COUNTUP_ENDS);
        }
    }

    private playCountUpEndSound():void {
        if(this._winCountupSoundRunning == true) {
            this._winCountupSoundRunning = false;
            SlotGame.sound.stopEffect(IceIceYetiSoundConfig.instance.COUNTUP);
            SlotGame.sound.playEffect(IceIceYetiSoundConfig.instance.COUNTUP_ENDS);
        }
    }

    private getWinAnimation(winType:WinRatioType):TimelineSprite {
        switch(winType) {
            case WinRatioType.LARGE :
                return this._largeWinAnimation;

            case WinRatioType.MEDIUM :
                return this._mediumWinAnimation;

            case WinRatioType.SMALL :
                return this._smallWinAnimation;

            default :
                return this._smallWinAnimation;
        }
    }

    public getEndAnimation(totalAmount:number, winType:WinRatioType, isAborted:boolean, delay:number = 0.5):TimelineLite {
        const tl:TimelineLite = new TimelineLite();
        tl.add([
            new TweenLite(this._scaleContainer.scale, 0.02, {
                x : this.getWinTypeScale(winType),
                y : this.getWinTypeScale(winType),
                ease : Power2.easeIn
            }),
            new TweenLite(this._scaleContainer, 0.02, {alpha : 1, ease : Linear.easeOut})
        ]);
        if(isAborted) {
            tl.add(this.getWinAnimationTL(winType));
        }
        tl.add(() => this.stopCountAt(totalAmount, winType));
        tl.add([
            new TweenLite(this._scaleContainer, 0.2, {alpha : 0, ease : Linear.easeOut})
        ], delay);
        tl.add(() => this._winAnimationPlayed = false);
        return tl;
    }

    private stopCountAt(to:number, winType:WinRatioType) {
        if(!this._hasStopped) {
            this._hasStopped = true;
        }
        this.playCountUpEndSound();
        this._countText.stopAt(to);
    }

    private getWinTypeScale(winType:WinRatioType):number {
        switch(winType) {
            case WinRatioType.LARGE :
                return 0.55;

            case WinRatioType.MEDIUM :
                return 0.5;

            case WinRatioType.SMALL :
                return 0.45;

            default :
                return 0.45;
        }
    }

    private getWinTypeSound(winType:WinRatioType):string {
        switch(winType) {
            case WinRatioType.LARGE :
                return IceIceYetiSoundConfig.instance.WIN_LARGE;

            case WinRatioType.MEDIUM :
                return IceIceYetiSoundConfig.instance.WIN_MEDIUM;

            case WinRatioType.SMALL :
                return IceIceYetiSoundConfig.instance.WIN_SMALL;

            default :
                return IceIceYetiSoundConfig.instance.WIN_TINY;
        }
    }
}